import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { ProblemProps } from './types.js';
import { getMessage } from './utils.js';

/** `<Problem>` component. */
export const Problem = ({
  agent,
  children,
  className,
  error,
  ...props
}: ProblemProps): ReactElement => (
  <div className={twMerge('flex flex-col gap-40', className)} {...props}>
    <div>
      <h1>{error.title ?? 'Error'}</h1>
      <p>{getMessage(error.code)}</p>
    </div>

    <p className='text-sm text-secondary'>
      [Error {agent.version ? `${agent.version}/` : ''}
      {error.code}]
    </p>

    {children}
  </div>
);
